import { render, staticRenderFns } from "./UserLikesModal.vue?vue&type=template&id=6f184176"
import script from "./UserLikesModal.vue?vue&type=script&lang=js"
export * from "./UserLikesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports